var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-xs-6 col-md-9" },
        [
          _c(
            "router-link",
            {
              attrs: {
                to: {
                  name: "managers.profile.show",
                  params: { id: _vm.staffUser.id },
                },
              },
            },
            [
              _c("div", { staticClass: "details" }, [
                _c("h3", [_vm._v(_vm._s(_vm.staffUser.name))]),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-xs-6 col-md-3 text-right" },
        [
          _c("toggle-button", {
            staticClass: "checkbox",
            attrs: {
              sync: true,
              width: 120,
              height: 25,
              labels: { checked: "Activated", unchecked: "Deactivated" },
              color: { checked: _vm.$brandPrimary, unchecked: "#b7b7b7" },
            },
            model: {
              value: _vm.activated,
              callback: function ($$v) {
                _vm.activated = $$v
              },
              expression: "activated",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }